import { render, staticRenderFns } from "./type3.vue?vue&type=template&id=d8d4dcc0&scoped=true&"
import script from "./type3.vue?vue&type=script&lang=js&"
export * from "./type3.vue?vue&type=script&lang=js&"
import style0 from "./type3.vue?vue&type=style&index=0&id=d8d4dcc0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8d4dcc0",
  null
  
)

export default component.exports